import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { ConverterExchangeProtocolEnum } from '@zaoblako/shared/modules/pacs/enums/converter-exchange-protocol.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link ConverterExchangeProtocolEnum} enumeration values */
export const ConverterExchangeProtocolEnumI18n: EnumI18nInterface<ConverterExchangeProtocolEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [ConverterExchangeProtocolEnum.TEST_MOCK_CONVERTER]: 'Протокол "Тестовый"',
    [ConverterExchangeProtocolEnum.IRON_LOGIC]: 'Протокол "Iron Logic WEB-JSON"',
  },
  [I18nLocalesEnum.EN_US]: {
    [ConverterExchangeProtocolEnum.TEST_MOCK_CONVERTER]: '"Test" protocol',
    [ConverterExchangeProtocolEnum.IRON_LOGIC]: '"Iron Logic WEB-JSON" protocol',
  },
};
